// --------------------------------------------------------------
// Created On: 2025-10-29
// Author: Zachary Thomas
//
// Last Modified: 2025-11-04
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { LOCAL_STORAGE_SESSION_TOKEN_KEY } from "src/constants/localStorageVariables";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Attempt to load initial state from local storage.
let initialToken = null;
const localStorageToken = localStorage.getItem(LOCAL_STORAGE_SESSION_TOKEN_KEY);
if (localStorageToken !== "") {
  initialToken = localStorageToken;
}

const initialState: string | null = initialToken;

// A Redux slice for the session token that is passed to the backend.
const sessionTokenSlice = createSlice({
  name: "sessionToken",
  initialState,
  reducers: {
    setSessionToken: (state, action: PayloadAction<string | null>) => {
      localStorage.setItem(LOCAL_STORAGE_SESSION_TOKEN_KEY, action.payload ?? "");
      return action.payload;
    },
  },
});

export const { setSessionToken } = sessionTokenSlice.actions;
export default sessionTokenSlice.reducer;
